module.exports = __webpack_public_path__ + "static/media/moi_logo.4ad22b40.png";